module.exports = __webpack_public_path__ + "img/qrcode.8cef5258.png";